import { z } from "zod";

import { packagingSolutionStagedSchema } from "../packaging-solution";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

export const auditEventStagedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Staged),
	data: packagingSolutionStagedSchema,
});

export type AuditEventStaged = z.infer<typeof auditEventStagedSchema>;
